import React from 'react';
//import './style.scss';
import moment from 'moment';

function Account({ item, newFeeds }) {
    const convertDateString = (date) => {
        let stillUtc = moment.utc(date).toDate();
        return moment(stillUtc).local().format('MM/DD/YYYY hh:mm');
    };

    return (
        <tr className={`table_row ${newFeeds && newFeeds.includes(Number(item.id)) && 'feed'}`}>
            
            <td className="table_column" style={{ verticalAlign: 'middle' }}>
                <strong className="table_lable">Email</strong>
                <div className="table-title_container">
                    <span id={`title-${item.id}`}>{item.email}</span>
                </div>
            </td>
            <td className="table_column" style={{ verticalAlign: 'middle' }}>
                <strong className="table_lable">Name</strong>
                {item.name}
            </td>
            <td className="table_column" style={{ verticalAlign: 'middle'}}>
                <strong className="table_lable">Active?</strong>
                <span id={'fb_active' + item.id}>
                    {item.isActive
                        ? <i style={{color: 'green'}} className="fas fa-check-circle"/>
                        : <i style={{color: '#db3c3c'}} className="fas fa-times-circle"/>
                    }
                </span>
            </td>
            {/*<td className="table_column" style={{ verticalAlign: 'middle'}}>*/}
            {/*    <strong className="table_lable">Public?</strong>*/}
            {/*    <span id={'fb_public' + item.id}>*/}
            {/*        {item.active_account*/}
            {/*            ? <i style={{color: 'green'}} className="fas fa-check-circle"/>*/}
            {/*            : <i style={{color: '#db3c3c'}} className="fas fa-times-circle"/>*/}
            {/*        }*/}
            {/*    </span>*/}
            {/*</td>*/}
            <td className="table_column" style={{ verticalAlign: 'middle' }}>
                <strong className="table_lable">Expired at</strong>
                {item.accessTokenExperienceData ? convertDateString(item.accessTokenExperienceData) : ''}
            </td>
            {/*<td className="table_column column_action" style={{ verticalAlign: 'middle' }}>*/}
            {/*    <strong className="table_lable">Hourly Limit</strong>*/}
            {/*    <div>*/}
            {/*        /!*<i onClick={() => deleteFeed(item, getUsersList)} className="feedsActions fas fa-trash-alt" id={'keks' + item.id} />*!/*/}
            {/*        {item.hourly_limit}*/}
            {/*    </div>*/}
            {/*</td>*/}
        </tr>
    );
}

export default Account;